import React from "react";

export const ErrorStep = (props) => {
  return (
    <>
      <div class="popup-header">
        <h4 class="popup-title">Error</h4>
      </div>
      <div class="popup-body-content">
        <div class="popup-description">
          <p>
            {Drupal.t("Sorry! Your recent attempt to view your PIN could not be completed. Please wait five minutes and then try again.")}
          </p>
          <p>
            {Drupal.t("If the problems persist, please reach out to customer support at support@secorepay.com")}
          </p>
        </div>
      </div>
    </>
  );
};
